<template>
    <div class="assets">
        <div class="section">
            <div class="title">委托信息：</div>


            <div class="item">
                <div class="label">
                    <span>*</span> 
                    案件性质:
                </div>
                <div class="input">
                    <el-select v-model="assets.caseCome" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in caseComeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div class="item">
                <div class="label">
                    <span>*</span> 
                    委托主体:
                </div>
                <div class="input">
                    <el-select v-model="assets.delegationType" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in delegationTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    委托方名称:
                </div>
                <el-autocomplete
                    class="inline-input"
                    v-model="assets.clientName"
                    :fetch-suggestions="querySearch"
                    placeholder=""
                    :trigger-on-focus="false"   
                    @select="handleSelect"
                    @keyup.enter.native="search"
                    size="small"
                >
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.name }}</div>
                    </template>
                </el-autocomplete>

            </div>
            
            <div class="item">
                <div class="label">
                    <span>*</span>
                    联系人:
                </div>
                <div class="input">
                    <el-input v-model="assets.contacts" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    联系电话:
                </div>
                <div class="input">
                    <el-input v-model="assets.clientPhone" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    联系地址:
                </div>
                <div class="input">
                    <el-input v-model="assets.clientAddress" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    委托日期:
                </div>
                <div class="input">
                    <el-date-picker
                    v-model="assets.entrustDate"
                    type="date"
                    size="small"
                    placeholder="选择日期">
                    </el-date-picker>
                    <!-- <el-input v-model="detail.assets.entrustDate" size="small" placeholder=""></el-input> -->
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span v-if="assets.delegationType==1||assets.delegationType==2">*</span>
                    <span v-else style="color:#ffffff">*</span>
                    报案号:
                </div>
                <div class="input">
                    <el-input v-model="assets.inCaseNo" size="small" placeholder=""></el-input>
                </div>
            </div>

            <div class="item">
                <div class="label">
                    <span>*</span>
                    评估标的名称:
                </div>
                <div class="input">
                    <el-input v-model="assets.targetName" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    标的所有人:
                </div>
                <div class="input">
                    <el-input v-model="assets.targetUseby" size="small" placeholder=""></el-input>
                </div>
            </div>

            <div class="item">
                <div class="label" style="width:150px">
                    委托评估鉴定事项:
                </div>
                <div class="textarea">
                    <el-input v-model="assets.entrustMatter" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
               
            </div>

            <div class="item">
                <div class="label" style="width:150px">
                    是否需出具报告:
                </div>
                <div class="input">
                    <el-select v-model="isReport" placeholder="请选择" size="small" @change="isReportChange">
                        <el-option
                        :key="true"
                        label="否"
                        :value="true">
                        </el-option>
                        <el-option
                        :key="false"
                        label="是"
                        :value="false">
                        </el-option>
                    </el-select>
                </div>
               
            </div>
            
        </div>
        <div class="section">
            <div class="title">案件信息：</div>
            <div class="item" v-if="isReport">
                <div class="label">
                    <span>*</span>
                    案件名称:
                </div>
                <div class="input">
                    <el-input v-model="assets.caseName" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    评估鉴定类别:
                </div>
                <div class="input">
                    <el-select v-model="assets.entrustType" filterable placeholder="请选择" size="small">
                        <el-option
                        v-for="item in assessStatusList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    评估鉴定地址:
                </div>
                <div class="input">
                    <el-input v-model="assets.entrustAddress" size="small" placeholder=""></el-input>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    <span>*</span>
                    案件类型:
                </div>
                <div class="input">
                    <el-cascader
                    v-model="assetsType"
                    :options="assetsTypeList"
                    size="small"
                    @change="handleAssetsTypeChange"
                    ></el-cascader>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    委托项目:
                </div>
                <div class="input">
                    <el-select v-model="assets.entrustedProject" filterable placeholder="请选择" size="small">
                        <el-option
                        v-for="item in entrustedProjectList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    案件名称:
                </div>
                <div class="input">
                    <el-input v-model="assets.caseName" size="small" placeholder=""></el-input>
                </div>
            </div> -->
            
            <!-- <div class="item">
                <div class="label">
                    <span>*</span>
                    保单号:
                </div>
                <div class="input">
                    <el-input v-model="assets.policyNo" size="small" placeholder=""></el-input>
                </div>
            </div> -->
            
            <!-- <div class="item">
                <div class="label">
                    <span>*</span>
                    事故地:
                </div>
                <div class="input">
                    <div class="input">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="assets.crimeCityCode"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
            </div> -->
            <div class="item">
                <div class="label">
                    <span>*</span>
                    事故日期:
                </div>
                <div class="input">
                    <!-- <el-input v-model="assets.damageTime" size="small" placeholder=""></el-input> -->
                    <el-date-picker
                    v-model="assets.damageTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                    </el-date-picker>
                    </div>
            </div>
            
            <div class="item">
                <div class="label">
                    是否重新评估鉴定:
                </div>
                <div class="input">
                    <el-select v-model="assets.entrustAgain" filterable placeholder="请选择" size="small">
                        <el-option key="是" label="是" value="是"></el-option>
                        <el-option key="否" label="否" value="否"></el-option>
                    </el-select>
                </div>
            </div>

            <div class="item">
                <div class="label">
                    <span>*</span>
                    评估鉴定用途:
                </div>
                <div class="input">
                    <el-select v-model="assets.entrustUse" filterable placeholder="请选择" size="small">
                        <el-option
                        v-for="item in assessPurposeList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    <span>*</span>
                    出险原因:
                </div>
                <div class="input">
                    <el-select v-model="assets.dangerReason" filterable placeholder="请选择" size="small">
                        <el-option
                        v-for="item in dangerList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div> -->
            <div class="item" style="width:100%">
                <div class="label">
                    案件详情:
                </div>
                <div class="textarea textarea-all">
                    <el-input v-model="assets.ajxq" type="textarea" :rows="3" size="small" placeholder=""></el-input>
                </div>
            </div>
            <!-- <div class="item">
                <div class="label">
                    委托内容:
                </div>
                <div class="textarea">
                    <el-input v-model="assets.content" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div> -->
            <div class="item">
                <div class="label">
                    评估鉴定风险提示:
                </div>
                <div class="textarea">
                    <el-input v-model="assets.entrustRisk" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    备注:
                </div>
                <div class="textarea">
                    <el-input v-model="assets.remark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>
        </div>

        <!-- <div class="section" v-if="assets.assetsType==1">
            <div class="title">物损信息</div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    物主:
                </div>
                <div class="input">
                    <el-input v-model="materialDamage.wuZhu" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    物损名称:
                </div>
                <div class="input">
                    <el-input v-model="materialDamage.wuSunName" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    受损情况:
                </div>
                <div class="textarea">
                    <el-input v-model="materialDamage.damageRemark" type="textarea" :rows="2" size="small" placeholder=""></el-input>
                </div>
            </div>
        </div> -->
        <div class="section" v-if="assets.assetsType==2">
            <div class="title">车辆信息</div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    车牌号:
                </div>
                <div class="input">
                    <el-input v-model="carDamage.licenseNo" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    车主:
                </div>
                <div class="input">
                    <el-input v-model="carDamage.owner" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    车架号:
                </div>
                <div class="input">
                    <el-input v-model="carDamage.vehicleNo" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    发动机号:
                </div>
                <div class="input">
                    <el-input v-model="carDamage.engineNo" size="small" placeholder=""></el-input>
                </div>
            </div>
            
        </div>
       

        <div class="section">
            <div class="title">调度信息</div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    派工机构:
                </div>
                <div class="input">
                    <el-select v-model="assets.pgMechanismId" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in mechanismList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    作业机构:
                </div>
                <div class="input">
                    <el-select v-model="assets.mechanismId" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in mechanismList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    <span>*</span>
                    作业人员:
                </div>
                <div class="input">
                    <el-select v-model="assets.operatorId" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in dispatcherList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item" v-if="!isReport">
                <div class="label">
                    <span>*</span>
                    预估公估费:
                </div>
                <div class="input">
                    <el-input v-model="assets.yuGuFee" type="number" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item" v-if="isReport">
                <div class="label">
                    <span>*</span>
                    评估费:
                </div>
                <div class="input">
                    <el-input v-model="assets.yuGuFee" type="number" size="small" placeholder=""></el-input>
                </div>
            </div>
            <div class="item" v-if="isReport">
                <div class="label">
                    <span>*</span>
                    评估金额:
                </div>
                <div class="input">
                    <el-input v-model="assets.jsFee" type="number" size="small" placeholder=""></el-input>
                </div>
            </div>
        </div>


        

        <div class="btn">
            <el-button type="primary" icon="el-icon-circle-plus" @click="submitCase">确认新增案件</el-button>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import {assetsTypeList,assetsStateList,delegationTypeList,caseComeList,dangerList,entrustedProjectList,assessStatusList,assessPurposeList} from '../../../assets/selectList/assetsSelectList'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
export default {
    name: 'addAsset',
    components:{
        
    },
    watch: {
        'assets.mechanismId':{
            handler:function(){
                this.queryDispatcherList();
            }
        }
    },
    data () {
        return {
            entrustedProjectList:entrustedProjectList,
            dangerList:dangerList,
            assetsType:['评估',1],
            assets:{
                assetsType:1,
                remark:'',
            },
            mechanismName:'',
            mechanismList:[],
            dispatcherList:[],
            assessPurposeList:assessPurposeList,
            assetsTypeList:assetsTypeList,
            assessStatusList:assessStatusList,
            delegationTypeList:delegationTypeList,
            caseComeList:caseComeList,
            options:provinceAndCityData,
            Province:'',
            CrimeCity:'',
            assetsMaps1:[],
            assetsMaps2:[],
            materialDamage:{
                assetsTypeStr:'物损评估',
            },
            carDamage:{
                assetsTypeStr:'车辆损失评估',
            },
            commonCarDamage:{
                assetsTypeStr:'车辆损失评估(共同委托)',
            },
            carInsurance:{
            },
            propertyInsurance:{

            },
            appraisalMaps:[],
            list:[],
            isReport:false,
        }
    },
    created(){
        

    },
    async mounted(){
        let res1  = await api.QueryMechanism({name:this.mechanismName});
        console.log(res1);
        this.mechanismList = res1.data.data.data;


        let res  = await api.queryBxCompnay({name:''});
        console.log(res);
        this.list = res.data.data;
    },
    methods:{
        isReportChange(e){
            if(this.isReport == false){
                if(this.assets.remark == '无需出具报告'){
                    this.assets.remark = ''
                }
            }else{
                this.assets.remark = '无需出具报告'
            }
            this.$forceUpdate();
        },
        handleAssetsTypeChange(){
            console.log(this.assetsType);
            // this.assets.assetsType = this.assetsType;
            this.assets.assetsType = this.assetsType[1];
        },
        handleRegionChange(codeArray){
            console.log(codeArray);
            if(codeArray[0]){
                this.Province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.CrimeCity = CodeToText[codeArray[1]]
            }
        },
        async querySearch(queryString, cb){
            let list = this.list;
            console.log(queryString);
            let results = queryString ? list.filter(this.createFilter(queryString)) : list;
            console.log(results);
            cb(results);
        },
        handleSelect(e){
            console.log(e);
            this.assets.clientName = e.name;
        },
        createFilter(queryString) {
            return (list) => {
                return (list.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        async queryDispatcherList(){
            let res  = await api.QueryUsers({MechanismId:this.assets.mechanismId,role:'机构作业员',pageSize:100});
            console.log(res);
            this.dispatcherList = res.data.data.data;
        },
        async createAssetsMaterialDamage(option){
            let res = await api.createAssetsMaterialDamage(option);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                })
                this.appraisalMaps=[];
                this.materialDamage={},
                this.assets={};
                console.log(res.data);
            }
        },
        async createAssetsCarDamage(option){
            let res = await api.createAssetsCarDamage(option);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                })
                this.appraisalMaps=[];
                this.carDamage={},
                this.assets={};
                
            }
        },
        async createAssetsCommonCarDamage(option){
            let res = await api.createAssetsCommonCarDamage(option);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                })
                this.appraisalMaps=[];
                this.commonCarDamage={},
                this.assets={};
                
            }
        },
        async createAssetsCarInsuranceAsync(option){
            let res = await api.createAssetsCarInsuranceAsync(option);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                })
                this.appraisalMaps=[];
                this.carInsurance={},
                this.assets={};
                
            }
        },
        async createAssetsPropertyInsuranceAsync(option){
            let res = await api.createAssetsPropertyInsuranceAsync(option);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                })
                this.appraisalMaps=[];
                this.propertyInsurance={},
                this.assets={};
                
            }
        },

        // 清空图片
        clearAssetsMaps1(index){
            this.assetsMaps1.splice(index,1)
        },
        clearAssetsMaps2(index){
            this.assetsMaps2.splice(index,1)
        },
        //上传前做一些事
        async beforeUpload(file){
            console.log(file);
            // console.log(file.name);
            var msg=file.name.substring(file.name.lastIndexOf('.')+1)
            msg = msg.toLowerCase();
            if(msg != 'jpg' && msg != 'png' && msg != 'jpeg') {
                this.$message({
                    message: '上传文件只能是 jpg、png、jpeg格式!',
                    type: 'warning'
                });
                return false;
            }
        },
        async uploadDataUpdateAssetsMaps1(file){
            let res = await api.uploadOther(file.file);
            this.assetsMaps1.push(res);
            return;
        },
        async uploadDataUpdateAssetsMaps2(file){
            let res = await api.uploadOther(file.file);
            this.assetsMaps2.push(res);
            return;
        },

         async submitCase(){
            
            this.assets.caseType = 2;
            if(!this.assets.delegationType){
                this.$message({
                    type: 'warning',
                    message: '请填写委托类型!'
                });
                return;
            }
            if(this.assets.delegationType==1||this.assets.delegationType==2){
                if(!this.assets.inCaseNo){
                    this.$message({
                        type: 'warning',
                        message: '请填写报案号!'
                    });
                    return;
                }
            }
            if(!this.assets.clientName){
                this.$message({
                    type: 'warning',
                    message: '请填写委托方名称!'
                });
                return;
            }
            if(!this.assets.contacts){
                this.$message({
                    type: 'warning',
                    message: '请填写联系人!'
                });
                return;
            }
            if(!this.assets.clientPhone){
                this.$message({
                    type: 'warning',
                    message: '请填写联系电话!'
                });
                return;
            }
            if(!this.assets.clientAddress){
                this.$message({
                    type: 'warning',
                    message: '请填写联系地址!'
                });
                return;
            }
            // if(!this.assets.caseName){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写案件名称!'
            //     });
            //     return;
            // }
            // if(!this.assets.entrustedProject){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写委托项目!'
            //     });
            //     return;
            // }
            
            // if(!this.assets.assetsType){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写案件类型!'
            //     });
            //     return;
            // }
            // if(!this.assets.policyNo){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写保单号!'
            //     });
            //     return;
            // }
           

            // if(!this.assets.crimeCityCode){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写事故地!'
            //     });
            //     return;
            // }
            if(!this.assets.damageTime){
                this.$message({
                    type: 'warning',
                    message: '请填写事故日期!'
                });
                return;
            }
            if(!this.assets.entrustDate){
                this.$message({
                    type: 'warning',
                    message: '请填写委托日期!'
                });
                return;
            }

            if(!this.assets.targetName){
                this.$message({
                    type: 'warning',
                    message: '请填写评估标的名称!'
                });
                return;
            }
            if(!this.assets.targetUseby){
                this.$message({
                    type: 'warning',
                    message: '请填写标的所有人!'
                });
                return;
            }
            if(!this.assets.entrustType){
                this.$message({
                    type: 'warning',
                    message: '请填写评估鉴定类别!'
                });
                return;
            }
            if(!this.assets.entrustUse){
                this.$message({
                    type: 'warning',
                    message: '请填写评估鉴定用途!'
                });
                return;
            }
            // if(!this.assets.dangerReason){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写出险原因!'
            //     });
            //     return;
            // }
            // if(!this.assets.ajxq){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写关键事项!'
            //     });
            //     return;
            // }
            
            if(this.assets.assetsType==1){
                // if(!this.materialDamage.wuZhu){
                //     this.$message({
                //         type: 'warning',
                //         message: '请填写物主!'
                //     });
                //     return;
                // }
                // if(!this.materialDamage.wuSunName){
                //     this.$message({
                //         type: 'warning',
                //         message: '请填写物损名称!'
                //     });
                //     return;
                // }
            }
            if(this.assets.assetsType==2){
                if(!this.carDamage.licenseNo){
                    this.$message({
                        type: 'warning',
                        message: '请填写车牌号!'
                    });
                    return;
                }
                if(!this.carDamage.owner){
                    this.$message({
                        type: 'warning',
                        message: '请填写车主!'
                    });
                    return;
                }
                if(!this.carDamage.vehicleNo){
                    this.$message({
                        type: 'warning',
                        message: '请填写车架号!'
                    });
                    return;
                }
                if(!this.carDamage.engineNo){
                    this.$message({
                        type: 'warning',
                        message: '请填写发动机号!'
                    });
                    return;
                }
            }


            if(!this.assets.pgMechanismId){
                this.$message({
                    type: 'warning',
                    message: '请填写派工机构!'
                });
                return;
            }
            if(!this.assets.mechanismId){
                this.$message({
                    type: 'warning',
                    message: '请填写作业机构!'
                });
                return;
            }
            if(!this.assets.operatorId){
                this.$message({
                    type: 'warning',
                    message: '请填写作业人员!'
                });
                return;
            }
            if(!this.assets.yuGuFee){
                this.$message({
                    type: 'warning',
                    message: '请填写预估公估费!'
                });
                return;
            }
            if(this.assets.yuGuFee<200){
                this.$message({
                    type: 'warning',
                    message: '预估公估费不能低于200!'
                });
                return;
            }

            for(let index in this.assetsMaps1){
                this.appraisalMaps.push({
                    "path": this.assetsMaps1[index],
                    "assetsMapsType": 10
                });
            }
            for(let index in this.assetsMaps2){
                this.appraisalMaps.push({
                    "path": this.assetsMaps2[index],
                    "assetsMapsType": 20
                });
            }
            let crimeCityCode = '';
            console.log(this.assets.crimeCityCode);
            for(let index in this.assets.crimeCityCode){
                if(index == 0){
                    crimeCityCode =this.assets.crimeCityCode[index]
                }else{
                    crimeCityCode = crimeCityCode+','+this.assets.crimeCityCode[index]
                }
            }
            this.assets.crimeCityCode = crimeCityCode
            this.assets.yuGuFee = parseFloat(this.assets.yuGuFee?this.assets.yuGuFee:0);
            this.assets.assetsType = parseInt(this.assets.assetsType);
            this.assets.jsFee = parseFloat(this.assets.jsFee?this.assets.jsFee:0);
            
            this.assets.assetsState =10;
            this.assets.crimeCity = this.Province+','+this.CrimeCity
           
            if(this.isReport){
                this.assets.assetsState = 100
                this.assets.fee = this.assets.yuGuFee
            }
            

            // console.log(this.assets);
            // return false;

            if(this.assets.assetsType==1){
                this.createAssetsMaterialDamage({
                    appraisalMaps:this.appraisalMaps,
                    materialDamage:this.materialDamage,
                    assets:this.assets,
                });
            }else if(this.assets.assetsType==2){
                this.createAssetsCarDamage({
                    appraisalMaps:this.appraisalMaps,
                    carDamage:this.carDamage,
                    assets:this.assets,
                });
            }
            
            else if(this.assets.assetsType==4){
              
                this.createAssetsPropertyInsuranceAsync({
                    appraisalMaps:this.appraisalMaps,
                    propertyInsurance:this.propertyInsurance,
                    assets:this.assets,
                });
            }
            else if(this.assets.assetsType==5){
                this.createAssetsCarInsuranceAsync({
                    assetsNalMap:this.appraisalMaps,
                    // carInsurance:this.carInsurance,
                    assets:this.assets,
                    // carLossList:[],
                });
            }else{
                this.createAssetsPropertyInsuranceAsync({
                    appraisalMaps:this.appraisalMaps,
                    propertyInsurance:this.propertyInsurance,
                    assets:this.assets,
                });
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
   
    .assets{
        display: flex;
        flex-wrap: wrap;
        background-color: #ffffff;
        .section{
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            border: 1px solid #DEDEDE;
            margin-bottom: 10px;
            padding-bottom: 10px;
            .title{
                width: 100%;
                font-weight: bold;
                font-size: 16px;
                margin-bottom: 12px;
                background-color: #DEDEDE;
                padding:8px 15px;
            }
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 4px;
                width: 120px;
                span{
                    color: red;
                }
            }
            .input{
                width: 215px;
                .el-date-editor.el-input, .el-date-editor.el-input__inner{
                    width: 215px;
                }
            }
            .textarea{
                width: 580px;
            }
            .textarea-all{
                max-width: 1314px;
                flex: auto;
            }
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
        .table{
            width: 100%;
            max-width: 1430px;
        }
        .card{
            width: 100%;
            max-width: 1430px;
            padding: 10px 15px;
        }
        .btn{
            padding:10px 15px;
            max-width: 1430px;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }


    .dialog{
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
